import { isDefined } from '@e-socna/utils';

import { ThirdPartyAddressesButton } from '../../../components/ThirdPartyAddressesButton';
import type { ActionableMessage } from '../../../components/ActionableMessages';

type QuotationActor = Readonly<{
  __typename?: string;
  thirdParty: Readonly<{
    __typename?: string;
    _id: string;
    billingAddress?: unknown;
  }>;
}>;

interface QuotationActors {
  readonly quotationEmitterActor: QuotationActor;
  readonly quotationReceiverActor: QuotationActor;
}

// A missing billing address, told with the action opening the addresses of the third party.
export const missingBillingAddressIssue = (
  { thirdParty }: QuotationActor,
  party: Readonly<{ label: string; ofLabel: string }>,
): ActionableMessage | null =>
  thirdParty.billingAddress
    ? null
    : {
        message: `${party.label} doit avoir exactement une adresse de facturation.`,
        action: (
          <ThirdPartyAddressesButton
            ofLabel={party.ofLabel}
            thirdParty={thirdParty}
          />
        ),
      };

// The Pennylane synchronization requires them: its main address is the billing one.
export const quotationActorsBlockingIssues = ({
  quotationEmitterActor,
  quotationReceiverActor,
}: Readonly<QuotationActors>): readonly ActionableMessage[] =>
  [
    missingBillingAddressIssue(quotationReceiverActor, {
      label: 'Le destinataire du devis',
      ofLabel: 'du destinataire du devis',
    }),
    quotationEmitterActor.__typename !== 'ActorOrganization'
      ? {
          message:
            "L'acteur émetteur du devis doit être une organisation, pas une personne physique.",
        }
      : null,
  ].filter(isDefined);
